import React from 'react'
//
import Table from "../../template/Table";

const Index = () => {

    let $conf = {
        optionFields: [],
        excludeFields: ['created_at'],
    }

    return <Table {...$conf}/>

}

export default Index;